import {
  LegacyModal,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@certn/cascadia-react";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { useOverlayTriggerState } from "react-stately";

const useTrustmaticMediaQuery = (query: string) => {
  const mediaMatch = window.matchMedia(query);
  const [matches, setMatches] = useState(mediaMatch.matches);

  useEffect(() => {
    const handler = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    if (mediaMatch?.addEventListener) {
      mediaMatch.addEventListener("change", handler);
    } else if (mediaMatch?.addListener) {
      mediaMatch.addListener(handler);
    }

    return () => {
      if (mediaMatch?.removeEventListener) {
        mediaMatch.removeEventListener("change", handler);
      } else if (mediaMatch?.removeListener) {
        mediaMatch.removeListener(handler);
      }
    };
  });
  return matches;
};

export const TrustmaticModal = ({
  show,
  onClose,
  trustmaticUrl,
  isError,
}: {
  show: boolean;
  onClose: () => void;
  trustmaticUrl: string;
  isError: boolean;
}) => {
  const fullscreenWidth = "940px";
  const baseHeight = "760px";
  const modalState = useOverlayTriggerState({});
  const useWideScreenSizes = useTrustmaticMediaQuery(
    `(min-width: ${fullscreenWidth})`
  );

  if (!show) {
    return null;
  }

  return (
    <ModalOverlay state={modalState}>
      <LegacyModal width={useWideScreenSizes ? fullscreenWidth : "100vw"}>
        <ModalHeader
          close={onClose}
          title=""
          hideDivider
          testID="trustmatic-modal"
        />
        <ModalContent>
          {isError ? (
            <Text style="global/body-primary" testID="trustmatic-modal-error">
              <Trans>Unable to start session. Please contact support.</Trans>
            </Text>
          ) : (
            trustmaticUrl && (
              <iframe
                src={trustmaticUrl}
                title="Trustmatic"
                data-testid="trustmatic-modal"
                allow="camera"
                frameBorder="0"
                style={{
                  height: baseHeight,
                  width: "100%",
                  margin: "auto",
                }}
              />
            )
          )}
        </ModalContent>
      </LegacyModal>
    </ModalOverlay>
  );
};
